// extracted by mini-css-extract-plugin
module.exports = {"preferencesCheckboxes":"PreferencesCheckboxes_preferencesCheckboxes__wkE5G","checkboxWrapper":"PreferencesCheckboxes_checkboxWrapper__ajnF8"};